module.exports = __webpack_public_path__ + "img/palo-alto-networks.c3b42de.svg";